import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export default function SectionQuote({FormRequestGlobal}) {

  const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal
  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
        Informacion de la cotizacion
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="monto_venta">Monto Total (Q)</label>
            <TextField
                id='monto_venta'
                name='monto_venta'
                value={ formState.monto_venta }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto Total'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="saldo_financiar">Monto a Financiar (Q)</label>
            <TextField
                id='saldo_financiar'
                name='saldo_financiar'
                value={ formState.saldo_financiar }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto a Financiar'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="monto_enganche">Monto del Enganche (Q)</label>
            <TextField
                id='monto_enganche'
                name='monto_enganche'
                value={ formState.monto_enganche }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto del Enganche'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="enganche">Porcentaje del Enganche (%)</label>
            <TextField
                id='enganche'
                name='enganche'
                value={ formState.enganche }
                onChange={ onInputChange }
                size='small'
                placeholder='Porcentaje del Enganche'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="interes_total">Interes Total (%)</label>
            <TextField
                id='interes_total'
                name='interes_total'
                value={ formState.interes_total }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto del Interes'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="interes">Porcentaje del Interes (%)</label>
            <TextField
                id='interes'
                name='interes'
                value={ formState.interes }
                onChange={ onInputChange }
                size='small'
                placeholder='Porcentaje del Interes'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="plazo_anios">Plazo en Años</label>
            <TextField
                id='plazo_anios'
                name='plazo_anios'
                value={ formState.plazo_anios }
                onChange={ onInputChange }
                size='small'
                placeholder='Plazo en Años'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="plazo">Plazo en Meses</label>
            <TextField
                id='plazo'
                name='plazo'
                value={ formState.plazo }
                onChange={ onInputChange }
                size='small'
                placeholder='Plazo en Meses'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="gps">GPS</label>
            <TextField
                id='gps'
                name='gps'
                value={ formState.gps }
                onChange={ onInputChange }
                size='small'
                placeholder='GPS'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="seguro">Seguro</label>
            <TextField
                id='seguro'
                name='seguro'
                value={ formState.seguro }
                onChange={ onInputChange }
                size='small'
                placeholder='Seguro'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="otros">Otros</label>
            <TextField
                id='otros'
                name='otros'
                value={ formState.otros }
                onChange={ onInputChange }
                size='small'
                placeholder='Otros'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="total_cuota">Total Cuota (Q)</label>
            <TextField
                id='total_cuota'
                name='total_cuota'
                value={ formState.total_cuota }
                onChange={ onInputChange }
                size='small'
                placeholder='Total Cuota'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="cuota_niv">Cuota Nivelada (Q)</label>
            <TextField
                id='cuota_niv'
                name='cuota_niv'
                value={ formState.cuota_niv }
                onChange={ onInputChange }
                size='small'
                placeholder='Cuota Nivelada'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
